import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import API_BASE from "../config/api";
import Swal from "sweetalert2";
import FilterBar from "./FilterBar";
import { Carousel } from "react-bootstrap";

function Listings() {
    const navigate = useNavigate();
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);
    const selectedProvince = queryParams.get("location") || "";
    const selectedCategory = queryParams.get("category") || "";
    const searchTerm = queryParams.get("search") || "";

    const [listings, setListings] = useState([]);
    const [loading, setLoading] = useState(true);

    const [showCallPopup, setShowCallPopup] = useState(false);
    const [showMsgPopup, setShowMsgPopup] = useState(false);

    const [selectedBiz, setSelectedBiz] = useState(null);
    const [userMsg, setUserMsg] = useState("");
    const [msgName, setMsgName] = useState("");
    const [msgMobile, setMsgMobile] = useState("");
    const [msgEmail, setMsgEmail] = useState("");
    const [msgSaving, setMsgSaving] = useState(false);
    const [showComplaintPopup, setShowComplaintPopup] = useState(false);
    const [complaintTopic, setComplaintTopic] = useState("");
    const [complaintMsg, setComplaintMsg] = useState("");
    const [filteredListings, setFilteredListings] = useState([]);

    // Right-side enquiry form
    const [enqName, setEnqName] = useState("");
    const [enqMobile, setEnqMobile] = useState("");
    const [enqEmail, setEnqEmail] = useState("");
    const [enqMessage, setEnqMessage] = useState("");
    const [enqLoading, setEnqLoading] = useState(false);

    const ITEMS_PER_PAGE = 10;
    const [currentPage, setCurrentPage] = useState(1);

    const goToProfile1 = (domain) => navigate(`/${domain}`);
    const goToPortfolio = (domain) => navigate(`/${domain}`);




    // 🔥 Fetch data from backend
    useEffect(() => {
        setLoading(true);

        fetch(
            `${API_BASE}/api/searchListings.php?location=${selectedProvince}&category=${selectedCategory}&search=${searchTerm}`
        )
            .then((res) => res.json())
            .then((data) => {
                const cleanData = (data.data || []).map((item) => ({
                    ...item,
                    is_verified: Number(item.is_verified) === 1 ? 1 : 0,
                    has_profile: Number(item.has_profile) === 1 ? 1 : 0,
                    has_website: Number(item.has_website) === 1 ? 1 : 0,
                    has_political: Number(item.has_political) === 1 ? 1 : 0,

                    // ✓ REAL ratings from DB (listing_comments)
                    rating: item.rating ? parseFloat(item.rating) : 0,
                    reviews: Number(item.review_count) || 0,
                }));

                setListings(cleanData);
                setFilteredListings(cleanData);
                setCurrentPage(1);
                setLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedProvince, selectedCategory, searchTerm]);

    const showToast = (message, icon) => {
        Swal.fire({
            toast: true,
            position: "top-end",
            icon: icon,
            title: message,
            showConfirmButton: false,
            timer: 1500,
            customClass: {
                popup:
                    icon === "success"
                        ? "my-toast my-toast-success"
                        : icon === "error"
                            ? "my-toast my-toast-error"
                            : "my-toast my-toast-warning",
            },
        });
    };

    const submitEnquiry = () => {
        if (!enqMobile || enqMobile.trim().length < 7) {
            showToast("Please enter a valid mobile number", "warning");
            return;
        }
        if (!enqEmail.trim()) {
            showToast("Please enter your email", "warning");
            return;
        }
        if (!enqMessage.trim()) {
            showToast("Please enter your message", "warning");
            return;
        }
        const category = selectedCategory || searchTerm;
        if (!category) {
            showToast("Please select a service category", "warning");
            return;
        }
        setEnqLoading(true);
        fetch(`${API_BASE}/api/save_service_enquiry.php`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                category,
                full_name: enqName.trim(),
                mobile: enqMobile.trim(),
                email: enqEmail.trim(),
                message: enqMessage.trim(),
            }),
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.success) {
                    showToast("Enquiry sent! We'll contact you soon.", "success");
                    setEnqName("");
                    setEnqMobile("");
                    setEnqEmail("");
                    setEnqMessage("");
                } else {
                    showToast("Could not send enquiry. Try again.", "error");
                }
            })
            .catch(() => showToast("Server error", "error"))
            .finally(() => setEnqLoading(false));
    };

    const totalPages = Math.ceil(filteredListings.length / ITEMS_PER_PAGE);
    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    const endIndex = startIndex + ITEMS_PER_PAGE;
    const paginatedListings = filteredListings.slice(startIndex, endIndex);

    const listingsScrollRef = useRef(null);
    useEffect(() => {
        if (!listingsScrollRef.current) return;
        const yOffset = -120;
        const y =
            listingsScrollRef.current.getBoundingClientRect().top +
            window.pageYOffset +
            yOffset;
        window.scrollTo({ top: y, behavior: "smooth" });
    }, [currentPage]);

    const getPageNumbers = () => {
        const maxPagesToShow = 5;
        let start = Math.max(1, currentPage - 2);
        let end = Math.min(totalPages, start + maxPagesToShow - 1);
        if (end - start < maxPagesToShow - 1) {
            start = Math.max(1, end - maxPagesToShow + 1);
        }
        return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    };

    // Heading / breadcrumb helpers
    const headingCat = selectedCategory || searchTerm || "Businesses";
    const headingLoc = selectedProvince || "Nepal";

    return (
        <div className="my-4">
            {/* INTERNAL CSS */}
            <style>{`
                .jd-breadcrumb { font-size: 13px; color: #6b7280; margin-bottom: 6px; }
                .jd-breadcrumb span { color: #2563eb; }
                .jd-heading { font-size: 24px; font-weight: 700; color: #0b1220; margin-bottom: 2px; }
                .jd-subheading { font-size: 13px; color: #6b7280; margin-bottom: 10px; }

                .jd-card { background: #fff; border: 1px solid #e5e7eb; border-radius: 12px; margin-bottom: 18px; overflow: hidden; transition: 0.2s; }
                .jd-card:hover { box-shadow: 0 6px 18px rgba(0,0,0,0.10); }
                .jd-card-img { width: 100%; height: 100%; min-height: 200px; max-height: 240px; object-fit: cover; }
                .jd-rating { background: #1ba672; color: #fff; font-weight: 700; font-size: 13px; padding: 2px 8px; border-radius: 6px; display: inline-flex; align-items: center; gap: 3px; }
                .jd-rating.jd-new { background: #6b7280; }
                .jd-reviews { font-size: 12px; color: #6b7280; }
                .jd-verified { color: #2563eb; font-size: 12px; font-weight: 600; display: inline-flex; align-items: center; gap: 3px; }
                .jd-tag { background: #f1f3f5; color: #374151; font-size: 11px; padding: 2px 8px; border-radius: 6px; }
                .jd-btn { border-radius: 6px; font-size: 14px; font-weight: 600; padding: 7px 16px; display: inline-flex; align-items: center; gap: 6px; border: 1px solid transparent; }
                .jd-btn-call { background: #1ba672; color: #fff; }
                .jd-btn-call:hover { background: #168a5f; color: #fff; }
                .jd-btn-wa { background: #fff; color: #1ba672; border-color: #1ba672; }
                .jd-btn-wa:hover { background: #e9faf2; }
                .jd-btn-enq { background: #2563eb; color: #fff; }
                .jd-btn-enq:hover { background: #1d4fd7; color: #fff; }
                .jd-btn-ghost { background: #fff; color: #374151; border-color: #d6dbe1; }
                .jd-btn-ghost:hover { background: #f6f8ff; }
                .jd-enquiry { background: #fff; border: 1px solid #e5e7eb; border-radius: 12px; padding: 16px; box-shadow: 0 4px 14px rgba(0,0,0,0.06); }
                .jd-enquiry h6 { font-weight: 700; color: #0b1220; }
                .jd-enquiry .form-control { border-radius: 8px; margin-bottom: 10px; }
                .corp-pagination { display: flex; align-items: center; gap: 8px; background: #fff; padding: 10px 14px; border-radius: 14px; box-shadow: 0 8px 22px rgba(0,0,0,0.12); }
                .corp-page-btn { border: 1px solid #dcdfe6; background: #fff; color: #3559E0; font-size: 15px; font-weight: 600; padding: 8px 14px; border-radius: 10px; cursor: pointer; transition: all 0.25s ease; min-width: 42px; }
                .corp-page-btn:hover:not(:disabled) { background: #eef2ff; border-color: #3559E0; }
                .corp-page-btn.active { background: #3559E0; color: #fff; border-color: #3559E0; }
                .corp-page-btn:disabled { opacity: 0.5; cursor: not-allowed; }
            `}</style>

            {/* BREADCRUMB + HEADING */}
            <div className="px-1">
                <div className="jd-breadcrumb">
                    Home <i className="bi bi-chevron-right" style={{ fontSize: 10 }}></i>{" "}
                    <span>{headingLoc}</span> <i className="bi bi-chevron-right" style={{ fontSize: 10 }}></i>{" "}
                    <span>{headingCat}</span> <i className="bi bi-chevron-right" style={{ fontSize: 10 }}></i>{" "}
                    {filteredListings.length}+ Listings
                </div>
                <h1 className="jd-heading">Best {headingCat} in {headingLoc}</h1>
                <p className="jd-subheading">
                    {filteredListings.length} result{filteredListings.length !== 1 ? "s" : ""} found
                </p>
            </div>

            <FilterBar
                listings={listings}
                onFilter={(data) => { setFilteredListings(data); setCurrentPage(1); }}
            />

            <div ref={listingsScrollRef}></div>

            <div className="row g-4">
                {/* LISTINGS (LEFT, WIDE) */}
                <div className="col-lg-8">

                    {loading && (
                        <div className="text-center my-5">
                            <div className="spinner-border text-primary" style={{ width: "4rem", height: "4rem" }} role="status"></div>
                            <p className="text-muted mt-3 fs-5">Loading results...</p>
                        </div>
                    )}

                    {!loading && filteredListings.length === 0 && (
                        <p className="text-muted fs-5">No results found.</p>
                    )}

                    {!loading && paginatedListings.map((biz) => (
                        <div key={biz.id} className="jd-card">
                            <div className="row g-0">
                                <div className="col-12 col-md-4">
                                    <img
                                        src={biz.profilepics && biz.profilepics.trim() !== "" ? biz.profilepics : "/assets/defaultList.jpg"}
                                        className="jd-card-img"
                                        alt={biz.title}
                                        onError={(e) => { e.target.onerror = null; e.target.src = "/assets/defaultList.jpg"; }}
                                    />
                                </div>

                                <div className="col-12 col-md-8 p-3">
                                    <h5 className="fw-bold mb-1">{biz.title}</h5>

                                    <div className="d-flex align-items-center gap-2 flex-wrap mb-1">
                                        {biz.reviews > 0 ? (
                                            <span className="jd-rating">{biz.rating} <i className="bi bi-star-fill" style={{ fontSize: 10 }}></i></span>
                                        ) : (
                                            <span className="jd-rating jd-new">New</span>
                                        )}
                                        <span className="jd-reviews">{biz.reviews} Reviews</span>
                                        {biz.is_verified === 1 && (
                                            <span className="jd-verified"><i className="bi bi-patch-check-fill"></i> Verified</span>
                                        )}
                                    </div>

                                    <p className="text-muted small mb-1">
                                        <i className="bi bi-geo-alt-fill text-danger"></i>{" "}
                                        {[biz.muncipality, biz.district, biz.province].filter(Boolean).join(", ")}
                                    </p>

                                    <div className="d-flex flex-wrap gap-1 mb-2">
                                        {biz.keywords && biz.keywords.split(",").map((k) => k.trim()).filter((k) => k.length > 0).slice(0, 4)
                                            .map((tag, i) => <span key={i} className="jd-tag">{tag}</span>)}
                                    </div>

                                    <div className="small mb-2">
                                        <div className="mb-1 d-flex align-items-center gap-2">
                                            <i className="bi bi-telephone-fill text-success"></i>
                                            <strong>{biz.showNumber ? biz.mobile : biz.mobile.slice(0, 2) + "XXXXXX" + biz.mobile.slice(-2)}</strong>
                                            <i
                                                className={`bi ms-1 ${biz.showNumber ? "bi-eye-slash" : "bi-eye"}`}
                                                style={{ cursor: "pointer", color: "#0d6efd" }}
                                                onClick={() => setListings((prev) => prev.map((item) => item.id === biz.id ? { ...item, showNumber: !item.showNumber } : item))}
                                            ></i>
                                        </div>
                                    </div>

                                    <div className="d-flex align-items-center flex-wrap gap-2 mt-2">
                                        <button className="jd-btn jd-btn-call" onClick={() => { setSelectedBiz(biz); setShowCallPopup(true); }}>
                                            <i className="bi bi-telephone-fill"></i>{biz.showNumber ? biz.mobile : "Call Now"}
                                        </button>
                                        <button className="jd-btn jd-btn-wa" onClick={() => { setSelectedBiz(biz); setUserMsg(""); setMsgName(""); setMsgMobile(""); setMsgEmail(""); setShowMsgPopup(true); }}>
                                            <i className="bi bi-whatsapp"></i> WhatsApp
                                        </button>
                                        <button className="jd-btn jd-btn-enq" onClick={() => { setSelectedBiz(biz); setUserMsg(""); setMsgName(""); setMsgMobile(""); setMsgEmail(""); setShowMsgPopup(true); }}>
                                            <i className="bi bi-chat-dots-fill"></i> Send Enquiry
                                        </button>
                                       
                                        {biz.has_website === 1 && biz.website_domain && (
                                            <button className="jd-btn jd-btn-ghost" onClick={() => goToProfile1(biz.website_domain)}><i className="bi bi-globe"></i> Website</button>
                                        )}
                                        {biz.has_profile === 1 && biz.portfolio_domain && (
                                            <button className="jd-btn jd-btn-ghost" onClick={() => goToPortfolio(biz.portfolio_domain)}><i className="bi bi-person-badge"></i> Portfolio</button>
                                        )}
                                        {biz.has_political === 1 && biz.political_domain && (
                                            <button className="jd-btn jd-btn-ghost" onClick={() => goToPortfolio(biz.political_domain)}><i className="bi bi-megaphone-fill"></i> Political</button>
                                        )}



                                        <i
                                            className="bi bi-exclamation-octagon-fill text-danger fs-5 ms-auto"
                                            style={{ cursor: "pointer" }}
                                            title="Report / Complaint"
                                            onClick={() => { setSelectedBiz(biz); setComplaintTopic(""); setComplaintMsg(""); setShowComplaintPopup(true); }}
                                        ></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}

                    {totalPages > 1 && (
                        <div className="d-flex justify-content-end mt-3">
                            <div className="corp-pagination">
                                <button className="corp-page-btn" disabled={currentPage === 1} onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}>‹ Prev</button>
                                {getPageNumbers().map((p) => (
                                    <button key={p} className={`corp-page-btn ${currentPage === p ? "active" : ""}`} onClick={() => setCurrentPage(p)}>{p}</button>
                                ))}
                                <button className="corp-page-btn" disabled={currentPage === totalPages} onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}>Next ›</button>
                            </div>
                        </div>
                    )}
                </div>

                {/* RIGHT SIDEBAR: ENQUIRY + ADS */}
                <div className="col-lg-4">
                    <div className="position-sticky" style={{ top: "120px" }}>
                    <div className="jd-enquiry">

                        <h6 className="mb-1">Get the list of best <span className="text-primary">{headingCat}</span></h6>
                        <p className="text-muted small mb-3">{headingCat} in {headingLoc}</p>
                        <input type="text" className="form-control" placeholder="Your Name" value={enqName} onChange={(e) => setEnqName(e.target.value)} />
                        <input type="tel" className="form-control" placeholder="Mobile Number" value={enqMobile} onChange={(e) => setEnqMobile(e.target.value.replace(/[^0-9]/g, ""))} maxLength={15} />
                        <input type="email" className="form-control" placeholder="Email" value={enqEmail} onChange={(e) => setEnqEmail(e.target.value)} />
                        <textarea
                            className="form-control"
                            rows="3"
                            placeholder="Your message"
                            value={enqMessage}
                            onChange={(e) => setEnqMessage(e.target.value)}
                        />
                        <button className="btn btn-primary w-100 fw-semibold" onClick={submitEnquiry} disabled={enqLoading}>
                            {enqLoading ? "Sending..." : "Send Enquiry  ›››"}
                        </button>

                        {filteredListings.length > 0 && (
                            <div className="mt-4">
                                <h6 className="mb-2"><i className="bi bi-hand-thumbs-up-fill text-primary me-1"></i> Customers' Top Picks</h6>
                                {[...filteredListings].sort((a, b) => b.rating - a.rating).slice(0, 3).map((b) => (
                                    <div key={`tp-${b.id}`} className="d-flex align-items-center gap-2 py-2 border-bottom">
                                        <img
                                            src={b.profilepics && b.profilepics.trim() !== "" ? b.profilepics : "/assets/defaultList.jpg"}
                                            alt={b.title}
                                            style={{ width: 40, height: 40, borderRadius: 8, objectFit: "cover" }}
                                            onError={(e) => { e.target.onerror = null; e.target.src = "/assets/defaultList.jpg"; }}
                                        />
                                        <div className="small" style={{ minWidth: 0 }}>
                                            <div className="fw-semibold text-truncate">{b.title}</div>
                                            <div className="text-muted">{b.reviews > 0 ? `${b.rating} ★ · ` : ""}{b.district || b.province}</div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    {/* ADS (moved to right rail) */}
                    <div className="card shadow-sm mt-3 mb-4" style={{ borderRadius: "10px", overflow: "hidden" }}>
                        <Carousel interval={2000} controls indicators>
                            <Carousel.Item><img src="/assets/L1.png" className="d-block w-100" alt="Ad 1" /></Carousel.Item>
                            <Carousel.Item><img src="/assets/L2.png" className="d-block w-100" alt="Ad 2" /></Carousel.Item>
                            <Carousel.Item><img src="/assets/L3.png" className="d-block w-100" alt="Ad 3" /></Carousel.Item>
                        </Carousel>
                    </div>
                    </div>
                </div>
            </div>

            {/* CALL POPUP */}

            {showCallPopup && selectedBiz && (
                <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" style={{ background: "rgba(0,0,0,0.5)", zIndex: 9999 }}>
                    <div className="bg-white p-4 rounded shadow" style={{ width: "320px" }}>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5 className="mb-0">{selectedBiz.title}</h5>
                            <button className="btn btn-sm btn-danger" onClick={() => setShowCallPopup(false)}>X</button>
                        </div>
                        <div className="text-center mb-3"><h4 className="fw-bold">{selectedBiz.mobile}</h4></div>
                        <button className="btn btn-success w-100 mb-2" onClick={() => (window.location.href = `tel:${selectedBiz.mobile}`)}><i className="bi bi-telephone-fill"></i> Call Now</button>
                        <button className="btn btn-outline-success w-100 mb-2" onClick={() => { setShowCallPopup(false); setUserMsg(""); setMsgName(""); setMsgMobile(""); setMsgEmail(""); setShowMsgPopup(true); }}><i className="bi bi-whatsapp"></i> WhatsApp Message</button>
                        <button className="btn btn-secondary w-100" onClick={() => { navigator.clipboard.writeText(selectedBiz.mobile); alert("Phone number copied!"); }}><i className="bi bi-clipboard-check"></i> Copy Number</button>
                    </div>
                </div>
            )}

            {/* MESSAGE POPUP */}
            {showMsgPopup && selectedBiz && (
                <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" style={{ background: "rgba(0,0,0,0.5)", zIndex: 9999 }}>
                    <div className="bg-white p-4 rounded shadow" style={{ width: "350px" }}>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5 className="mb-0">Message {selectedBiz.title}</h5>
                            <button className="btn btn-sm btn-danger" onClick={() => setShowMsgPopup(false)}>X</button>
                        </div>
                        <input
                            className="form-control mb-2"
                            placeholder="Full name"
                            value={msgName}
                            onChange={(e) => setMsgName(e.target.value)}
                        />
                        <input
                            type="tel"
                            className="form-control mb-3"
                            placeholder="Mobile number"
                            value={msgMobile}
                            onChange={(e) => setMsgMobile(e.target.value.replace(/[^0-9]/g, ""))}
                            maxLength={15}
                        />
                        <input
                            type="email"
                            className="form-control mb-3"
                            placeholder="Email"
                            value={msgEmail}
                            onChange={(e) => setMsgEmail(e.target.value)}
                        />
                        <p className="fw-bold small">Choose a message:</p>
                        {["Hello! I want to know more about your services.", "Please share pricing details.", "I am interested, please contact me.", "Is this service available right now?"].map((msg, idx) => (
                            <button key={idx} onClick={() => setUserMsg(msg)} className="btn btn-outline-secondary text-start mb-2 w-100">{msg}</button>
                        ))}
                        <textarea className="form-control mt-2" rows="3" placeholder="Type your message..." value={userMsg} onChange={(e) => setUserMsg(e.target.value)}></textarea>
                        <button className="btn btn-success w-100 mt-3" disabled={msgSaving} onClick={async () => {
                            if (!msgName.trim() || msgMobile.trim().length < 7 || !msgEmail.trim()) {
                                showToast("Please enter your full name, email and valid mobile number", "warning");
                                return;
                            }
                            if (!userMsg.trim()) {
                                showToast("Please choose or type a message", "warning");
                                return;
                            }
                            const phone = selectedBiz.mobile.replace(/[^0-9]/g, "");
                            const text = encodeURIComponent(userMsg.trim());
                            const whatsappWindow = window.open("about:blank", "_blank");
                            setMsgSaving(true);
                            try {
                                const response = await fetch(`${API_BASE}/api/save_service_enquiry.php`, {
                                    method: "POST",
                                    headers: { "Content-Type": "application/json" },
                                    body: JSON.stringify({
                                        category: selectedCategory || searchTerm || selectedBiz.title,
                                        full_name: msgName.trim(),
                                        mobile: msgMobile.trim(),
                                        email: msgEmail.trim(),
                                        message: userMsg.trim(),
                                        listinguid: selectedBiz.listinguid || "",
                                    }),
                                });
                                const data = await response.json();
                                if (!data.success) {
                                    if (whatsappWindow) whatsappWindow.close();
                                    showToast(data.message || "Could not save enquiry", "error");
                                    return;
                                }
                                if (whatsappWindow) {
                                    whatsappWindow.location.href = `https://wa.me/${phone}?text=${text}`;
                                } else {
                                    window.open(`https://wa.me/${phone}?text=${text}`, "_blank");
                                }
                                setShowMsgPopup(false);
                            } catch {
                                showToast("Server error. Please try again.", "error");
                            } finally {
                                setMsgSaving(false);
                            }
                        }}>
                            <i className="bi bi-whatsapp"></i> Send on WhatsApp
                        </button>
                    </div>
                </div>
            )}

            {/* COMPLAINT POPUP */}
            {showComplaintPopup && selectedBiz && (
                <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" style={{ background: "rgba(0,0,0,0.5)", zIndex: 2000 }}>
                    <div className="bg-white p-4 rounded shadow" style={{ width: "360px" }}>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5 className="mb-0">Report Issue</h5>
                            <button className="btn btn-sm btn-danger" onClick={() => setShowComplaintPopup(false)}>X</button>
                        </div>
                        <label className="fw-semibold small">Complaint Type</label>
                        <select className="form-select mb-3" value={complaintTopic} onChange={(e) => setComplaintTopic(e.target.value)}>
                            <option value="">Select Topic</option>
                            <option>Fake Business</option>
                            <option>Wrong Information</option>
                            <option>Fraud / Scam</option>
                            <option>Duplicate Listing</option>
                            <option>Other</option>
                        </select>
                        <label className="fw-semibold small">Your Message</label>
                        <textarea className="form-control mb-3" rows="3" placeholder="Write your complaint..." value={complaintMsg} onChange={(e) => setComplaintMsg(e.target.value)}></textarea>
                        <button className="btn btn-dark w-100" onClick={async () => {
                            if (!complaintTopic || !complaintMsg) { showToast("Please fill all fields", "error"); return; }
                            const listingUid = selectedBiz.listinguid ?? selectedBiz.listing_uid ?? selectedBiz.id ?? "";
                            if (!listingUid) { showToast("Listing UID missing!", "error"); return; }
                            const payload = { listing_uid: listingUid, topic: complaintTopic, message: complaintMsg };
                            try {
                                const res = await fetch(`${API_BASE}/api/saveComplaint.php`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) });
                                const data = await res.json();
                                if (data.success) { showToast(data.message || "Complaint submitted successfully!", "success"); setShowComplaintPopup(false); }
                                else { showToast(data.message || "Something went wrong", "error"); }
                            } catch (err) { showToast("Server error", "error"); }
                        }}>Submit Complaint</button>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Listings;